export default __webpack_public_path__ + "static/media/018-wealth.557f79b2.svg";